<template>
  <v-container fluid>
    <v-row class="py-5">
      <v-col cols="12" sm="6">
        <quicksearch v-model="ticketsearch" :immediate="true"></quicksearch>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          label="Status"
          :items="statusItems"
          v-model="status"
          outlined dense hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          label="Categoria"
          :items="categoryItems"
          v-model="category"
          multiple chips
          outlined dense hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-autocomplete
          label="Tag Heppi"
          :items="tagItems"
          v-model="tag"
          multiple chips
          outlined dense hide-details
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-card outlined elevation="0">
      <div v-if="reference === 'celebration' && !asanaID" class="pa-2 text-center">Nenhum ID do asana configurado</div>
      <div v-else-if="!loading && lastTickets.length === 0" class="pa-2 text-center">Nenhum ticket para o filtro solicitado</div>
      <v-list v-else class="pb-0 pt-0">
        <v-list-item v-if="!loading">
          <v-list-item-content>
            <v-list-item-subtitle class="text-right">Mostrando {{ lastTickets.length === 100 ? 'os últimos 100 tickets' : lastTickets.length === 1 ? '1 ticket' : `${lastTickets.length} tickets` }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider v-if="!loading" />
        <template v-for="(item, index) in lastTickets">
          <v-divider v-if="index > 0" :key="'support=divider-' + index" />
          <v-list-item two-line :key="'support-item-' + index" @click="openTicketDetails(item.gid)">
            <v-list-item-content>
              <v-list-item-title>{{ item.gid }}: <b>{{ item.name }}</b></v-list-item-title>
              <v-list-item-subtitle>
                <v-chip
                  v-for="membership in item.memberships"
                  :key="membership.project.gid"
                  x-small outlined label class="mr-1 pr-0"
                  :color="ticketStatusColor(membership.section.name)"
                >
                  {{ membership.project.name }}
                  <v-chip x-small class="ml-2" label :color="ticketStatusColor(membership.section.name)">{{ membership.section.name }}</v-chip>
                </v-chip>
              </v-list-item-subtitle>
              <v-list-item-subtitle class="mt-1">
                <!-- Turma/entidade: <b>{{ celebrationName(item) }}</b> -->
                Categoria: <b>{{ categoryName(item) }}</b>
                <br />
                Tag: {{ tagName(item) }}
                <br />
                <template v-if="reference === 'celebration' && participantName(item)">
                  Participante: <b>{{ participantName(item) }}</b>
                  <br />
                </template>
                Última atualização: {{ item.modified_at | moment('DD/MM/YYYY HH:mm') }} <template v-if="item.due_on">| Conclusão: {{ item.due_on | moment('DD/MM/YYYY') }}</template>
                <br />
                Responsável: {{ item.assignee && item.assignee.name }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </template>
        <v-divider v-if="loading" />
        <v-list-item v-if="loading">
          <v-list-item-content>
            <v-list-item-title class="text-center">Carregando...</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <support-request-dialog :openedTicket="openedTicket" @close="openedTicket = null" @updateList="getTickets(true)" />
  </v-container>
</template>

<script>
import axios from 'axios'
import Quicksearch from '@/components/Quicksearch'
import SupportRequestDialog from '@/components/SupportRequestDialog'

export default {
  name: 'TicketTabList',
  components: {
    Quicksearch,
    SupportRequestDialog
  },
  props: {
    id: {
      type: String,
      default: null
    },
    asanaID: {
      type: String,
      default: null
    },
    reference: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      loading: false,
      ticketsearch: '',
      status: '',
      category: [],
      tag: [],
      lastTickets: [],
      totalTickets: 0,
      nextTickets: null,
      openedTicket: null,
      timeoutTicketGet: null,
      participants: []
    }
  },
  computed: {
    statusItems () {
      return [
        { value: 'opened', text: 'Em Aberto' },
        { value: 'ended', text: 'Finalizados' },
        { value: '', text: 'Todos os tickets' }
      ]
    },
    categoryItems () {
      const itemsList = this.lastTickets.map(t => {
        if (t.custom_fields) {
          const categoryItem = t.custom_fields.find(c => c.gid === '1210003440646954')
          if (categoryItem && categoryItem.display_value) return categoryItem.display_value
        }
        return 'Sem categoria'
      })
      return [...new Set(itemsList)]
    },
    tagItems () {
      const itemsList = this.lastTickets.map(t => {
        if (t.custom_fields) {
          const tagItem = t.custom_fields.find(c => c.gid === '1210005442056343')
          if (tagItem && tagItem.display_value) return tagItem.display_value
        }
        return 'Sem tag'
      })
      return [...new Set(itemsList)]
    },
    params () {
      const params = {
        resource_subtype: 'default_task',
        sort_by: 'modified_at',
        sort_ascending: false,
        opt_fields: 'name, due_on, modified_at, assignee.name, memberships.section.name, memberships.project.name, custom_fields.display_value'
      }
      if (this.reference === 'celebration' && this.asanaID) params['custom_fields.1207534182103018.value'] = this.asanaID
      if (this.reference === 'participant' && this.id) params['custom_fields.1207534684719483.value'] = 'https://support.heppi.io/participantes/' + this.id
      if (this.heppiSupport) params['projects.any'] = this.heppiSupport
      else params['projects.any'] = '1207826522655672,1207826521026912,1207826522655675,1207826522655669'
      if (this.status) params.completed = this.status === 'ended'
      if (this.ticketsearch) params.text = this.ticketsearch
      return params
    },
    // celebrationName () {
    //   return (item) => {
    //     if (item.custom_fields) {
    //       const celebrationField = item.custom_fields.find(c => c.gid === '1207534182103018')
    //       if (celebrationField && celebrationField.display_value) {
    //         return celebrationField.display_value
    //       }
    //     }
    //     return ''
    //   }
    // }
    categoryName () {
      return (item) => {
        if (item.custom_fields) {
          const categoryItem = item.custom_fields.find(c => c.gid === '1210003440646954')
          if (categoryItem && categoryItem.display_value) {
            return categoryItem.display_value
          }
        }
        return '-'
      }
    },
    tagName () {
      return (item) => {
        if (item.custom_fields) {
          const categoryItem = item.custom_fields.find(c => c.gid === '1210005442056343')
          if (categoryItem && categoryItem.display_value) {
            return categoryItem.display_value
          }
        }
        return '-'
      }
    },
    participantName () {
      return (item) => {
        if (item.custom_fields) {
          const participantField = item.custom_fields.find(c => c.gid === '1207534684719483')
          if (participantField && participantField.display_value) {
            const participantSplit = participantField.display_value.split('/')
            const participantID = participantSplit[participantSplit.length - 1]
            const participant = this.participants.find(p => p.id === participantID)
            if (participant && participant.name) return participant.name
          }
        }
        return ''
      }
    }
  },
  watch: {
    status () {
      this.getTickets(true)
    },
    ticketsearch () {
      clearTimeout(this.timeoutTicketGet)
      this.timeoutTicketGet = setTimeout(() => {
        this.getTickets(true)
      }, 700)
    }
  },
  methods: {
    openTicketDetails (item) {
      this.openedTicket = item
    },
    ticketStatusColor (status) {
      if (status === 'Finalizado') return 'success'
      if (status === 'Impedido') return 'error'
      if (status === 'Em andamento' || status === 'À fazer') return 'primary'
      return 'grey-4'
    },
    getTickets (refresh) {
      this.loading = true
      if (refresh) this.lastTickets = []
      this.$store.dispatch('asanaApi', { method: 'GET', url: 'workspaces/1202385686519626/tasks/search', params: this.params })
        .then(response => {
          this.lastTickets = [...this.lastTickets, ...response.data.filter(t => t.memberships && t.memberships.length > 0)]
        })
        .catch(() => {
          this.lastTickets = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    getParticipants (page) {
      axios.get('participants?page[size]=30&page[number]=' + (page || 1) + '&&filter[celebration_id]=' + this.id)
        .then(response => {
          if (!page) this.participants = []
          if (response.data && response.data.data) {
            for (const i in response.data.data) {
              const participant = response.data.data[i]
              this.participants.push({
                id: participant.id || '',
                name: (participant.customer && participant.customer.name) || ''
              })
            }
          }
          if (response.data.meta.last_page > 1) {
            if (!page) this.getParticipants(2)
            else if (page < response.data.meta.last_page) this.getParticipants(page + 1)
          }
        })
        .catch(() => {
          this.participants = []
        })
    }
  },
  async mounted () {
    this.loading = true
    if (this.reference === 'celebration') await this.getParticipants()
    this.getTickets(true)
  }
}
</script>
